import * as Yup from "yup";


export const dataModel = {
  department: [],
  year: "",
  numEvaluations: "",
  goals1: "",
  goals2: "",
  goals3: "",
  goals4: "",
  goals5: "",
  competencies1: "",
  competencies2: "",
  competencies3: "",
  competencies4: "",
  competencies5: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      department: Yup.string().required("forms.validations.required"),
      year: Yup.string().required("forms.validations.required"),
      numEvaluations: Yup.string().required("forms.validations.required"),
      goals1: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      goals2: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      goals3: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      goals4: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      goals5: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      competencies1: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      competencies2: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      competencies3: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      competencies4: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
      competencies5: Yup.number()
        .required("forms.validations.required")
        .min(0, "forms.validations.min", { min: 0 })
        .max(5, "forms.validations.max5", { max: 5 }),
    });
  }

  return Yup.object().shape({
    department: Yup.string().required("forms.validations.required"),
    year: Yup.string().required("forms.validations.required"),
    numEvaluations: Yup.string().required("forms.validations.required"),
    goals1: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    goals2: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    goals3: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    goals4: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    goals5: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    competencies1: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    competencies2: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    competencies3: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    competencies4: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
    competencies5: Yup.number()
      .required("forms.validations.required")
      .min(0, "forms.validations.min", { min: 0 })
      .max(5, "forms.validations.max5", { max: 5 }),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
